import { render } from "./TagForm.vue?vue&type=template&id=1ee38216"
import script from "./TagForm.vue?vue&type=script&lang=js"
export * from "./TagForm.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TagForm.vue?vue&type=style&index=0&id=1ee38216&module=true&lang=scss"
cssModules["$style"] = style0

import exportComponent from "/home/runner/work/pulse/pulse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__